var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3627 7.36325C14.5653 7.64745 14.6667 7.78959 14.6667 7.99992C14.6667 8.21025 14.5653 8.35239 14.3627 8.63659C13.4519 9.91365 11.1261 12.6666 8 12.6666C4.87385 12.6666 2.54806 9.91365 1.63735 8.63659C1.43467 8.35239 1.33333 8.21025 1.33333 7.99992C1.33333 7.78959 1.43467 7.64745 1.63735 7.36325C2.54806 6.08621 4.87385 3.33325 8 3.33325C11.1261 3.33325 13.4519 6.08621 14.3627 7.36325Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 6.8954 9.1046 6 8 6C6.8954 6 6 6.8954 6 8C6 9.1046 6.8954 10 8 10C9.1046 10 10 9.1046 10 8Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.25004e53da24ec736cb49192febd1e7f.svg";
export { ForwardRef as ReactComponent };